import { render } from "./validating-panel-placeholder.vue?vue&type=template&id=f2bf5394&scoped=true&ts=true"
import script from "./validating-panel-placeholder.vue?vue&type=script&lang=ts"
export * from "./validating-panel-placeholder.vue?vue&type=script&lang=ts"

import "./validating-panel-placeholder.vue?vue&type=style&index=0&id=f2bf5394&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2bf5394"]])

export default __exports__